import styled, { css } from 'styled-components';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
import { getFontSize, getFont } from '@finect/tabular-utils/getFont';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1o28qna-0"
})(["position:relative;"]);
export var ChartContainer = styled.div.withConfig({
  displayName: "partials__ChartContainer",
  componentId: "sc-1o28qna-1"
})(["min-height:120px;"]);
export var Actions = styled.div.withConfig({
  displayName: "partials__Actions",
  componentId: "sc-1o28qna-2"
})(["padding:7px 14px;> div{", ";display:flex;align-items:center;span{margin-left:4px;}svg{vertical-align:middle;}}"], getFont(-1));
export var DetailCardBlock = styled.div.withConfig({
  displayName: "partials__DetailCardBlock",
  componentId: "sc-1o28qna-3"
})(["position:absolute;z-index:10;top:100px;right:0;width:320px;padding-bottom:16px;border:1px solid ", ";border-radius:4px;box-shadow:", ";background-color:", ";transform:translateX(364px);"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows.lightBlack;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.cardsBackgroundColor);
});
export var LegendBlock = styled.div.withConfig({
  displayName: "partials__LegendBlock",
  componentId: "sc-1o28qna-4"
})(["padding:7px 14px;"]);
export var LegendLine = styled.div.withConfig({
  displayName: "partials__LegendLine",
  componentId: "sc-1o28qna-5"
})(["display:flex;margin-bottom:9px;"]);
export var LineName = styled.div.withConfig({
  displayName: "partials__LineName",
  componentId: "sc-1o28qna-6"
})(["height:14px;font-size:", "rem;line-height:14px;", ";"], getFontSize(-1), textEllipsis);
export var CircleContainer = styled.div.withConfig({
  displayName: "partials__CircleContainer",
  componentId: "sc-1o28qna-7"
})(["display:flex;align-items:center;height:14px;margin-right:4px;"]);
export var Circle = styled.div.withConfig({
  displayName: "partials__Circle",
  componentId: "sc-1o28qna-8"
})(["display:inline-block;width:", ";height:", ";border-radius:", ";", " ", ""], function (props) {
  return "".concat(2 * props.radius, "px");
}, function (props) {
  return "".concat(2 * props.radius, "px");
}, function (props) {
  return "".concat(props.radius, "px");
}, function (_ref4) {
  var index = _ref4.index,
    theme = _ref4.theme;
  return index && index === 1 && css(["background-color:", ";"], theme.colors.primary);
}, function (_ref5) {
  var index = _ref5.index,
    theme = _ref5.theme;
  return index && index === 2 && css(["background-color:", ";"], theme.colors.secondary);
});